

import { withInstall } from "@/utils/install";
import SchameForm from "./src/schema-form.vue";
SchameForm.name = "ltAForm";
export const ltAForm = withInstall(SchameForm);
export default ltAForm;
// export * from "./src/schema-form";
